var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.downloadFile()}}},[_vm._v(_vm._s(_vm.resolvedDisplayName))])}
var staticRenderFns = []

export { render, staticRenderFns }